import React from 'react';

import { iconBaseProps, type IconProps } from './IconBase';

const MoonIcon: React.FC<IconProps> = props => (
  <svg {...iconBaseProps} {...props}>
    <path d="M20 14.5A8 8 0 0 1 9.5 4a8 8 0 1 0 10.5 10.5z" />
  </svg>
);

export default MoonIcon;
